// Single source of truth for all ClassTree design values.
// Consume via the MUI theme (preferred) or import directly where MUI's
// palette isn't available (e.g. recharts `stroke`/`fill` props).

export const colors = {
  primary:      '#4F46E5',
  primaryLight: '#EEF2FF',
  primaryDark:  '#3730A3',
  secondary:    '#EC4899',
  success:      '#10B981',
  warning:      '#F59E0B',
  error:        '#EF4444',
  info:         '#06B6D4',
  // neutrals
  textPrimary:   '#1E293B',
  textSecondary: '#64748B',
  bgDefault:     '#F8FAFC',
  bgPaper:       '#FFFFFF',
  border:        '#E2E8F0', // grey.200 equivalent
};

export const spacing = { xs: 4, sm: 8, md: 16, lg: 24, xl: 32 };

export const radii = { sm: 8, md: 12, lg: 16 };

export const fontWeights = { regular: 400, medium: 500, semibold: 600, bold: 700 };
